import Iso from './iso';
import IsoB from './isoB';
import IsoC from './isoC';
import IsoD from './isoD';
import IsoE from './isoE';
import IsoF from './isoF';
import IsoG from './isoG';
import IsoH from './isoH';
import IsoI from './isoI';
import Nso from './nso';
import NsoB from './nsoB';
import NsoC from './nsoC';
import NsoD from './nsoD';
import NsoE from './nsoE';
import NsoF from './nsoF';
import NsoG from './nsoG';
import NsoH from './nsoH';
import NsoI from './nsoI';
import NsoJ from './nsoJ';
import NsoK from './nsoK';
import NsoL from './nsoL';
import NsoM from './nsoM';
import NsoN from './nsoN';

const pages = {
  iso: {
    component: Iso,
    onBackgroundClickGoTo: 'isoB'
  },
  isoB: {
    component: IsoB
  },
  isoC: {
    // by clicking yes
    component: IsoC
  },
  isoD: {
    // by clicking no
    component: IsoD
  },

  //the three questions in C
  isoE: {
    //1
    component: IsoE
  },
  isoF: {
    //2
    component: IsoF
  },
  isoG: {
    //3
    component: IsoG
  },
  //the question after G
  isoH: {
    //yes
    component: IsoH
  },

  isoI: {
    //3
    component: IsoI
  },

  nso: {
    // first nso
    component: Nso,
    onBackgroundClickGoTo: 'nsoB'
  },
  nsoB: {
    // yes / no
    component: NsoB
  },
  nsoC: {
    // by clicking yes
    component: NsoC
  },
  nsoD: {
    // by clicking no
    component: NsoD
  },
  nsoE: {
    // after yes the first answer
    component: NsoE
  },
  nsoF: {
    component: NsoF
  },
  nsoG: {
    component: NsoG
  },
  nsoH: {
    component: NsoH
  },
  nsoI: {
    component: NsoI
  },
  nsoJ: {
    component: NsoJ
  },
  nsoK: {
    component: NsoK
  },
  nsoL: {
    component: NsoL
  },
  nsoM: {
    component: NsoM
  },
  nsoN: {
    component: NsoN
  }
};

export default pages;
